<template>
  <div id="tooltip">
    <div class="grid-column ai-c jc-s gap-10">
      <div v-if="$slots.default">
        <slot />
      </div>
      <div
        v-else
        :class="['sac__font-14', !dark ? 'f-white' : '', 'med']"
      >
        {{ label }}
      </div>
      <div class="tooltip-icon">
        <span
          class="icon-luc-Info"
          :style="{ color: color || 'white', fontSize: iconSize ? `${iconSize}px` : '16px' }"
        />
        <div class="tip-container sac__font-12 n90">
          <slot name="tooltip">
            {{ tip }}
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACTooltip',
  props: {
    tip: String,
    label: String,
    med: Boolean,
    small: Boolean,
    dark: Boolean,
    light: Boolean,
    color: String,
    iconSize: Number,
    bgColor: String,
  },
};
</script>

<style lang="scss" scoped>
#tooltip {
  .tooltip-icon {
    position: relative;
    margin-top: -2px;

    &:hover {
      .tip-container {
        display: block;
        background-color: $WHITE;
      }
    }

    .tip-container {
      display: none;
      position: absolute;
      background-color: $WHITE;
      bottom: 30px;
      left: -50px;
      padding: 7px 16px;
      box-shadow: 0 6px 6px rgba(9, 15, 32, 0.07);
      border-radius: 6px;
      width: 235px;
      z-index: 999;

      &:hover {
        display: block;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 2px;
        left: 27px;
        width: 0;
        height: 0;
        border: 8px solid transparent;
        border-top-color: $WHITE;
        margin-left: -8px;
        margin-bottom: -8px;
      }
    }
  }
}
</style>
